var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPromotionBanner = function SvgPromotionBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 319,
    viewBox: "0 0 68 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 319,
    fill: "#FF0018"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 160,
    transform: "rotate(-90 34 160)",
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 22,
    letterSpacing: 3,
    fill: "white"
  }, "PROMOTION")));
};
export { SvgPromotionBanner as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjgiIGhlaWdodD0iMzE5IiB2aWV3Qm94PSIwIDAgNjggMzE5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iNjgiIGhlaWdodD0iMzE5IiBmaWxsPSIjRkYwMDE4Ii8+Cjx0ZXh0IHg9IjM0IiB5PSIxNjAiIHRyYW5zZm9ybT0icm90YXRlKC05MCAzNCAxNjApIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIgogICAgICBmb250LWZhbWlseT0iQXJpYWwsIEhlbHZldGljYSwgc2Fucy1zZXJpZiIgZm9udC13ZWlnaHQ9IjcwMCIgZm9udC1zaXplPSIyMiIgbGV0dGVyLXNwYWNpbmc9IjMiIGZpbGw9IndoaXRlIj5QUk9NT1RJT048L3RleHQ+Cjwvc3ZnPgo=";